export const ROLE_LABELS = {
  admin: 'Stratel Admin',
  stratel_admin: 'Stratel Admin',
  consultant: 'Consultant',
  consultant_lead: 'Consultant Lead',
  org_admin: 'Headquarters Admin',
  org_team: 'Headquarters Team',
  facility_admin: 'Facility Admin',
  facility_manager: 'Facility Manager',
  facility_worker: 'Facility Team Member (Training)',
  worker: 'Agency Worker',
};

export function formatRoleLabel(role) {
  if (!role) return '';
  return ROLE_LABELS[role] || role.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
}

export function isClientWorkerRole(userOrRole) {
  const role = typeof userOrRole === 'string' ? userOrRole : userOrRole?.role;
  return role === 'facility_worker';
}

export function isAgencyWorkerRole(userOrRole) {
  const role = typeof userOrRole === 'string' ? userOrRole : userOrRole?.role;
  return role === 'worker';
}
